import Alert from "@/components/alert.vue";
import { usePopup } from "@/utils/popup";
import { ref } from "vue";

const { show: popupShow } = usePopup();
const showResolve = ref(null);

const popupOpts = {
    header: '알림',
    isClose: false,
    modalMaskStyle: {zIndex: 99999}
}

const show = (message) => {
    return new Promise(resolve => {
        popupShow(Alert, popupOpts, {message}, null);
        showResolve.value = resolve;
    });
}

const hide = () => {
    showResolve.value();
}

const useAlert = () => {
    return show;
}

export { useAlert, hide };
